import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper2(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { Component } from 'react';
import Screens from '..';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants, { MOUNT_INTENTS } from '../../utils/routeParamConstants';
import Utils from '../../utils';
import SSOLinksInterface from '../../api/SSOLinksInterface';
import { SSOLinksResponseKeys } from '../../api/Constants';
import audio from '../../utils/audio';
import PlayerInterface from '../../api/PlayerInterface';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import { isStar } from '../../utils/targetApplication';
import NotificationContext from '../../context/NotificationContext';
import { onGuestActivate } from '../../utils/guestLogin';

var Start = /*#__PURE__*/function (_Component) {
  function Start(props) {
    var _this2;

    _classCallCheck(this, Start);

    _this2 = _callSuper2(this, Start, [props]);
    _this2.isRN = Utils.isReactNative();
    _this2.checkRecoverPassRequest = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var urlParams, id, token, platform, recoverRequest;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              urlParams = QueryParamsProxy.getAllParams();

              if (urlParams) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              id = urlParams.i;
              token = urlParams.t;
              platform = urlParams.platform;

              if (!(id && token && platform)) {
                _context.next = 11;
                break;
              }

              _context.next = 9;
              return PlayerInterface.recoverPasswordTokenCheck({
                id: id,
                token: token
              });

            case 9:
              recoverRequest = _context.sent;

              if (!recoverRequest.success) {
                _this2.setState({
                  showRecoverPass: {
                    visible: true,
                    invalid: true,
                    message: recoverRequest.error
                  }
                });
              } else {
                _this2.setState({
                  showRecoverPass: {
                    visible: true,
                    invalid: false,
                    id: id,
                    token: token
                  }
                });
              }

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    _this2.closeModal = function () {
      audio.onClick();
      audio.playSfx('popUpReverse', true, 1);

      _this2.setState({
        isVisible: false,
        terms: false,
        showSignUpForm: false,
        showRecoverPass: _objectSpread(_objectSpread({}, _this2.state.showRecoverPass), {}, {
          visible: false
        })
      });
    };

    _this2.openModal = function (mountIntent) {
      audio.playSfx('popUp', true, 1);

      _this2.setState({
        isVisible: true,
        terms: false,
        termsAccepted: false,
        mountIntent: mountIntent
      });
    };

    _this2._loginHandler = function () {
      if (ENVIRONMENT_VARIABLES.SSO_ENABLED === 'true') {
        _this2.setState({
          isLoading: true
        });

        QueryParamsProxy.navigate(_this2.props.navigation, Screens.SSOLogin);
      } else {
        QueryParamsProxy.navigate(_this2.props.navigation, Screens.Login);
      }
    };

    _this2._ssoLoginHandler = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var ssoLinks, destinationUrl;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.setState({
                isLoading: true
              });

              _context2.next = 3;
              return SSOLinksInterface.getSSOLinks();

            case 3:
              ssoLinks = _context2.sent;
              destinationUrl = ssoLinks[SSOLinksResponseKeys.LOGIN_URL];

              if (ENVIRONMENT_VARIABLES.SSO_DEV === 'true') {
                destinationUrl = destinationUrl.replace(new RegExp("(redirect_uri=)(.*)(/".concat(ENVIRONMENT_VARIABLES.SSO_CALLBACK_PATH, ")")), "$1".concat(document.location.origin, "$3"));
              }

              document.location = destinationUrl;

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    _this2.onStarActivate = function () {
      audio.onClick();
      _this2.isRN ? _this2._loginHandler() : _this2._ssoLoginHandler();
    };

    _this2.onAccountActivate = function () {
      audio.onClick();

      _this2._loginHandler();
    };

    _this2.handleGuestActivate = function () {
      return onGuestActivate(_this2.state.termsAccepted, _this2.state.mountIntent, _this2.setState.bind(_this2), _this2.openModal, _this2.closeModal, _this2.context.addNotification);
    };

    _this2.onFacebookActivate = function () {
      audio.onClick();
      var _this2$state = _this2.state,
          termsAccepted = _this2$state.termsAccepted,
          mountIntent = _this2$state.mountIntent;

      if (termsAccepted && mountIntent === MOUNT_INTENTS.FACEBOOK_LOGIN) {
        _this2.props.mountIntent.facebook();
      } else {
        _this2.openModal(MOUNT_INTENTS.FACEBOOK_LOGIN);
      }
    };

    _this2.onGoogleActivate = function () {
      audio.onClick();
      var _this2$state2 = _this2.state,
          termsAccepted = _this2$state2.termsAccepted,
          mountIntent = _this2$state2.mountIntent;

      if (termsAccepted && mountIntent === MOUNT_INTENTS.GOOGLE_LOGIN) {
        _this2.props.mountIntent.google();
      } else {
        _this2.openModal(MOUNT_INTENTS.GOOGLE_LOGIN);
      }
    };

    _this2.onAppleActivate = function () {
      audio.onClick();
      var _this2$state3 = _this2.state,
          termsAccepted = _this2$state3.termsAccepted,
          mountIntent = _this2$state3.mountIntent;

      if (termsAccepted && mountIntent === MOUNT_INTENTS.APPLE_LOGIN) {
        _this2.props.mountIntent.apple();
      } else {
        _this2.openModal(MOUNT_INTENTS.APPLE_LOGIN);
      }
    };

    _this2.setTerms = function () {
      audio.onClick();

      _this2.setState({
        terms: !_this2.state.terms
      });
    };

    _this2.onSubmit = function () {
      audio.onClick();

      _this2.setState({
        termsAccepted: true
      }, function () {
        _this2.closeModal();

        switch (_this2.state.mountIntent) {
          case MOUNT_INTENTS.FACEBOOK_LOGIN:
            _this2.onFacebookActivate();

            break;

          case MOUNT_INTENTS.APPLE_LOGIN:
            _this2.onAppleActivate();

            break;

          case MOUNT_INTENTS.GOOGLE_LOGIN:
            _this2.onGoogleActivate();

            break;

          case MOUNT_INTENTS.GUEST_LOGIN:
            _this2.handleGuestActivate();

            break;

          default:
            break;
        }
      });
    };

    _this2._signupHandler = function () {
      if (ENVIRONMENT_VARIABLES.APPLICATION_TARGET === 'star') {
        QueryParamsProxy.navigate(_this2.props.navigation, Screens.Signup);
      } else {
        audio.onClick();

        _this2.setState({
          showSignUpForm: true
        });
      }
    };

    _this2._cancelHandler = function () {
      QueryParamsProxy.navigate(_this2.props.navigation, Screens.Start);
    };

    _this2.state = {
      isVisible: false,
      terms: false,
      socialError: false,
      isLoading: false,
      mountIntent: '',
      termsAccepted: false,
      showSignUpForm: false,
      showRecoverPass: {}
    };
    return _this2;
  }

  _inherits(Start, _Component);

  return _createClass(Start, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      Utils.getPlatform() === 'web' && this.checkRecoverPassRequest();
      audio.playSfx('crowdsTalking', true, 0.7);
      var currentSrceen = this.props.navigation.state.routeName;
      audio.setCurrentScreen(currentSrceen); // if the token and restart token are present, the player is logged in and should not be able to access the start screen
      // this is used to ensure the back button does not bring players to this screen

      if (this.props.token.token !== '' && this.props.restart.token !== '') {
        audio.fadeOut('crowdsTalking');
        QueryParamsProxy.navigate(this.props.navigation, Screens.Lobby);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      audio.fadeOut('crowdsTalking');
      audio.setCurrentScreen('');
    }
  }, {
    key: "render",
    value: function render() {
      return (// Pass state and handlers to platform renderer
        this.props.token.token === '' && this.props.render({
          loginHandler: this._loginHandler,
          onGuestActivate: this.handleGuestActivate,
          onFacebookActivate: this.onFacebookActivate,
          onGoogleActivate: this.onGoogleActivate,
          onAppleActivate: this.onAppleActivate,
          onAccountActivate: isStar ? this.onStarActivate : this.onAccountActivate,
          signupHandler: this._signupHandler,
          statusMessage: this.props.navigation.getParam(RouteParamConstants.PARAM_STATUS_MESSAGE),
          statusAction: this.props.navigation.getParam(RouteParamConstants.PARAM_ACTION),
          googleAuthServiceAvailable: this.props.googleAuthServiceAvailable,
          isVisible: this.state.isVisible,
          terms: this.state.terms,
          isLoading: this.state.isLoading,
          closeModal: this.closeModal,
          onSubmit: this.onSubmit,
          setTerms: this.setTerms,
          termsAndConditionsUrl: this.props.assetsUrls ? this.props.assetsUrls.termsAndConditions : '',
          privacyPolicyUrl: this.props.assetsUrls ? this.props.assetsUrls.privacyPolicy : '',
          showSignUpForm: this.state.showSignUpForm,
          recoverPasswordResponse: this.state.showRecoverPass,
          hasFacebook: hasFacebook
        })
      );
    }
  }]);
}(Component);

Start.contextType = NotificationContext;
export { Start as default };
var hasFacebook = ENVIRONMENT_VARIABLES.FACEBOOK_LOGIN === 'true';